import { StyleSheet } from 'aphrodite';
import { altTabDark, altTabLight, header, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: 14,
		fontStyle: 'normal',
		fontWeight: 'normal',
		justifyContent: 'space-between',
	},
	filterContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: 24,
		'@media (max-width: 1440px)': {
			flexDirection: 'column',
			gap: 8,
		},
		width: '100%',
	},
	filterBar: {
		gap: 8,
	},
	filterLabel: {
		flexShrink: 0,
		paddingRight: 6,
	},
	noEventSelected: {
		color: header,
	},
	pageHeaderText: {
		fontSize: 18,
	},
	pageSubHeaderText: {
		fontSize: 14,
		fontWeight: 'normal',
		paddingTop: 10,
		margin: 0,
	},
	selectBoxOption: {
		fontSize: 14,
	},
	tabsContainer: {
		width: '100%',
	},
	tabViewContainer: {
		paddingTop: 20,
	},
	tabViewContent: {
		display: 'none',
	},
	tabViewItem: {
		background: altTabLight,
		border: `1px solid ${altTabDark}`,
		borderRadius: 4,
		color: altTabDark,
		display: 'inline-flex',
		flexBasis: 'auto',
		flexGrow: 0,
		fontSize: 14,
		padding: '0 20px',
		textAlign: 'center',
		textTransform: 'none',
		whiteSpace: 'nowrap',
	},
	tabViewSelectedItem: {
		':before': {
			borderLeft: '14px solid transparent',
			borderRight: '14px solid transparent',
			borderTop: `10px solid ${altTabDark}`,
			content: "' '",
			display: 'block',
			left: 'calc(50% - 14px)',
			overflow: 'visible',
			position: 'absolute',
			top: '100%',
		},
		background: altTabDark,
		color: 'white !important',
		overflow: 'visible',
		position: 'relative',
	},
	tabViewSelectedTabIndicator: {
		display: 'none',
	},
	tabViewTabbar: {
		height: 40,
	},
	tabViewTabs: {
		borderBottom: 'none',
		display: 'flex',
	},
	dropdownTrigger: {
		minWidth: 200,
		background: white,
	},
	newEmailButtonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	tabsRoot: {
		flex: 1,
	},
});
